import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar } from 'lucide-react';
import { Reveal } from './Reveal';

const formatDate = (d) =>
  new Date(d).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });

export const ActualitesSection = ({ articles }) => {
  if (!articles || articles.length === 0) return null;

  return (
    <section className="section-spacing bg-cream">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <Reveal className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <p className="text-xs uppercase tracking-[0.25em] font-semibold text-warm-accent mb-4">Veille & actualités</p>
            <h2 className="font-heading text-3xl md:text-5xl font-light tracking-tight text-primary-blue">
              Restez informé des dernières évolutions
            </h2>
          </div>
          <Link to="/actualites" data-testid="actualites-cta-all" className="group inline-flex items-center gap-2 font-medium text-primary-blue whitespace-nowrap">
            Toutes les actualités
            <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {articles.slice(0, 3).map((article, i) => {
            const isExternal = Boolean(article.lien);
            const Wrapper = isExternal ? 'a' : Link;
            const linkProps = isExternal
              ? { href: article.lien, target: '_blank', rel: 'noopener noreferrer' }
              : { to: '/actualites' };
            return (
              <Reveal key={article.id} delay={i * 100}>
                <Wrapper
                  {...linkProps}
                  data-testid={`actualite-card-${article.id}`}
                  className="group block h-full"
                >
                  <div className="h-1 w-16 bg-warm-accent mb-5 transition-all duration-300 group-hover:w-24" />
                  <div className="flex items-center gap-3 text-xs text-text-gray mb-3">
                    <span className="uppercase tracking-wider font-semibold text-primary-blue">{article.categorie}</span>
                    <span className="flex items-center gap-1">
                      <Calendar className="w-3.5 h-3.5" />
                      {formatDate(article.datePublication)}
                    </span>
                  </div>
                  <h3 className="font-heading text-xl font-medium text-text-dark leading-snug group-hover:text-warm-accent transition-colors duration-300">
                    {article.titre}
                  </h3>
                  {article.source && (
                    <p className="text-sm text-text-gray mt-3">Source : {article.source}</p>
                  )}
                </Wrapper>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
